<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Supplier List
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        small
        v-if="checkPermission('app_infor:b2b_create_supplier_mapping')"
        @click="$router.push('/supplier')"
        class="mr-8"
        >Add Supplier</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      item-key="id"
      :headers="headers"
      :items="supplierList"
      :options.sync="options"
      :server-items-length="total"
      :loading="supplierLoader"
      class="elevation-1 custom-icon-size mr-8"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-form>
          <div class="custom-row">
            <v-col cols="12" sm="3">
              <v-text-field
                label="Supplier Name"
                outlined
                v-model="supplier_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                label="Supplier Code"
                outlined
                v-model="supplier_code"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-btn color="white" @click="clearAll" style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                class="success mr-2"
                @click="searchAll"
                style="float: right"
                >Search</v-btn
              >
              <span style="float: right">
                <v-btn
                  color="primary"
                  class="mb-2 mr-2"
                  @click="syncData()"
                  :loading="syncLoader"
                  v-if="checkPermission('app_infor:b2b_sync_supplier')"
                  >Sync</v-btn
                ></span
              >
            </v-col>
          </div>
        </v-form>
        <v-divider class="mb-5"></v-divider>
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at"
          >{{ item.created_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
          <span v-if="item.created_by__name"
            ><br />({{ item.created_by__name }})</span
          ></span
        >
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at"
          >{{ item.updated_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        </span>
      </template>
      <template v-slot:[`item.address1`]="{ item }">
        {{ item.address1 }}<span v-if="item.address2">,</span
        >{{ item.address2 }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_infor:b2b_linking_supplier')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="linksupplier(item)">
              mdi-link-box-outline
            </v-icon>
          </template>
          <span>Link Supplier</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Link Supplier</span>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text class="pb-0">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-if="
                    userCategory.user_category === 3 ||
                    userCategory.user_category === 6
                  "
                  v-model="client_id"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  outlined
                  label="Client Name"
                  class="required"
                  :rules="[(v) => !!v || 'Client is required']"
                  required
                  @focus="fetchClientList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="supplier_name_display"
                  label="Supplier Name-Code"
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pl-6 pt-0">
          <v-btn @click="submit" color="primary"> Save </v-btn>

          <v-btn
            color="primary"
            class="error"
            @click="(dialog = false), $refs.form.reset()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  created() {
    this.fetchClientList();
  },
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    supplier_name_display: "",
    syncLoader: false,
    selectAll: false,
    supplier_name: null,
    supplier_code: null,
    clients: [],
    dialog: false,
    headers: [
      {
        text: "Supplier Name",
        value: "supplier_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Supplier Code",
        value: "supplier_code",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Country",
        value: "country",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 100,
      },
      {
        text: "City",
        value: "city",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Address",
        value: "address1",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Phone Number",
        value: "phone",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },

      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 130,
      },
      {
        text: "Updated At",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Action",
        value: "actions",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
    ],
    supplierList: [],
    options: {},
    total: 0,
    filtersArr: {},
    supplierLoader: false,
    client_id: null,
  }),

  watch: {
    options: {
      handler() {
        this.getlist();
        this.selectedEntry = [];
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getSupplierList",
      "syncSupplier",
      "fetchClient",
      "linkedSupplier",
    ]),
    fetchClientList() {
      if (this.clients.length) return;

      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    syncData() {
      this.syncLoader = true;

      this.syncSupplier()
        .then((res) => {
          this.syncLoader = false;

          this.snackBar({
            color: "success",
            message: res.data.message,
          });

          this.getlist();
        })
        .catch(() => {
          this.syncLoader = false;
        });
    },
    linksupplier(item) {
      this.linkItem = item;
      this.supplier_name_display =
        item.supplier_name + " - " + item.supplier_code;
      this.dialog = true;
    },
    submit() {
      if (this.$refs.form.validate()) {
        let payload = {
          client_id: this.client_id,
          supplier_code: this.linkItem.supplier_code,
        };
        this.linkedSupplier(payload)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.$refs.form.reset();
          })
          .catch(() => {
            this.dialog = false;
            this.linkItem = null;
            this.$refs.form.reset();
          });
      }
    },
    allFilters() {
      let obj = {
        supplier_name: this.supplier_name
          ? this.supplier_name.trim()
          : this.supplier_name,
        supplier_code: this.supplier_code
          ? this.supplier_code.trim()
          : this.supplier_code,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getSupplierList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.supplierLoader = false;
          this.supplierList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.supplierLoader = false;
        });
    },
    clearAll() {
      this.supplier_code = null;
      this.supplier_name = null;
      this.searchAll();
    },

    getlist() {
      this.supplierLoader = true;
      this.getSupplierList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.supplierLoader = false;
          this.supplierList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.supplierLoader = false;
        });
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 5px 5px 5px !important;
}
</style>
